import { CustomHighcharts } from 'components/shared/CustomHighcharts';
import { Loader } from 'components/shared/Loader';

import { useTranslation } from 'react-i18next';
import { MissingKeywordsList } from './MissingKeywordsList';

export const SemanticResultsBox = ({ analyseResult, loading, list }) => {
  const { t } = useTranslation();

  const greenWordsWithRemainingFreq =
    analyseResult?.greenWordsByFreq?.greenWordsWithRemainingFreq;
  const remainingKeywords = analyseResult?.remainingKeywords;

  return (
    <div
      className="box-wrapper box-list-text"
      style={{ maxHeight: '284px', height: 'auto' }}
    >
      <div className="header-title mb-0">{t('Résultat sémantique')}</div>

      <div className="box-graph">
        {loading && <Loader />}

        {analyseResult?.semanticEnrichment >= 0 && (
          <div className="d-flex flex-wrap">
            <div className="mx-auto">
              <CustomHighcharts value={analyseResult.semanticEnrichment} />
            </div>

            {analyseResult.semanticEnrichment < 100 && (
              <div className="me-auto">
                <b>{t('Mots clés restants')}:</b>

                {greenWordsWithRemainingFreq &&
                  Object.keys(greenWordsWithRemainingFreq).length > 0 && (
                    <MissingKeywordsList
                      items={greenWordsWithRemainingFreq}
                      originalItems={list}
                    />
                  )}

                {remainingKeywords &&
                  Object.keys(remainingKeywords).length > 0 && (
                    <MissingKeywordsList items={remainingKeywords} />
                  )}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
